import { createIcon } from '../icon'
import FilledHeartIcon from '../svg/FilledHeartIcon'

export const FilledHeartIconDefault = createIcon(FilledHeartIcon)
